"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// hash of bundle dependencies, example: { [bundleId]: [productId1, productId2] }
const isCartHasInvalidBundles = (lineItems, hash) => {
    if (!lineItems.length || !Object.keys(hash).length)
        return false;
    const cartBundlesHash = lineItems.reduce((acc, lineItem) => {
        if (lineItem.bundleId) {
            acc[lineItem.bundleId] = [...(acc[lineItem.bundleId] || []), lineItem.productId];
        }
        return acc;
    }, {});
    return Object.keys(cartBundlesHash).some(cartBundleId => JSON.stringify(cartBundlesHash[cartBundleId].sort()) !== JSON.stringify(hash[cartBundleId].sort()));
};
exports.default = isCartHasInvalidBundles;
//# sourceMappingURL=isCartHasInvalidBundles.js.map